import { useForm } from 'react-hook-form';
import { SVButton, SVForm, SVPasswordInput } from './core';
import { UpdatePasswordFields } from '@/types/common';
import PasswordRules from './PasswordRules';
import { FORM_FIELDS } from '@/constants/formFields';

type UpdatePasswordFormProps = {
  isActivation?: boolean;
  isLoading: boolean;
  handleSubmit: (data: UpdatePasswordFields) => void | Promise<void>;
};

export default function UpdatePasswordForm({
  isActivation = false,
  isLoading,
  handleSubmit,
}: UpdatePasswordFormProps) {
  const formMethods = useForm<UpdatePasswordFields>({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
    mode: 'onBlur',
  });

  return (
    <>
      <PasswordRules />
      <SVForm<UpdatePasswordFields>
        methods={formMethods}
        onSubmit={handleSubmit}>
        <SVPasswordInput
          name="password"
          label={isActivation ? 'Password' : 'New Password'}
        />
        <SVPasswordInput
          name="confirmPassword"
          passwordName="password"
          {...FORM_FIELDS.CONFIRM_PASSWORD}
        />
        <SVButton isLoading={isLoading} type="submit">
          Submit
        </SVButton>
      </SVForm>
    </>
  );
}
